import { render, staticRenderFns } from "./TourExitButton.vue?vue&type=template&id=1c164848&scoped=true&"
import script from "./TourExitButton.vue?vue&type=script&lang=js&"
export * from "./TourExitButton.vue?vue&type=script&lang=js&"
import style0 from "./TourExitButton.vue?vue&type=style&index=0&id=1c164848&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c164848",
  null
  
)

export default component.exports